import styled from 'styled-components';

export default styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  transition: border-bottom 180ms ease-in-out;

  &:hover {
    border-bottom: 10px solid red;
  }
`;
